import React from 'react';
import { useParams } from 'react-router-dom';
import PrinterMapWidget from './PrinterMapWidget';

const PartnerMapWidget = () => {
  const { partnerName } = useParams();
  return <PrinterMapWidget filterName={partnerName} />;
};

export default PartnerMapWidget;
